// extracted by mini-css-extract-plugin
export default {"requiredMark":"SwippyDateTimeInput_requiredMark__dHcnZ"};